import { render, staticRenderFns } from "./ProjectDetailItem.vue?vue&type=template&id=06ab1278&"
import script from "./ProjectDetailItem.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports